module.exports = __webpack_public_path__ + "img/face19.a936eab2.gif";